var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.11,63.17s-54.24-40.07-123.57-18S180,126.85,140.73,168.78c-20.58,22-51.34,31.11-75.92,48.41-78.61,55.33-64.95,171-3,212,53.66,35.53,120,36.47,205.78,4.53S414.86,382.19,467,299.57,468,117.87,401.11,63.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.11,63.17s-54.24-40.07-123.57-18S180,126.85,140.73,168.78c-20.58,22-51.34,31.11-75.92,48.41-78.61,55.33-64.95,171-3,212,53.66,35.53,120,36.47,205.78,4.53S414.86,382.19,467,299.57,468,117.87,401.11,63.17Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Docs--inject-66"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.61 143.44 29.03 143.44 29.03 84.09 69.51 84.09 76.61 90.01 76.61 143.44",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.51 84.09 69.51 90.11 76.61 90.11 69.51 84.09",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.78,
    y: 89.08,
    width: 35.52,
    height: 12.97
  })), /*#__PURE__*/React.createElement("line", {
    x1: 34.29,
    y1: 105.76,
    x2: 72.6,
    y2: 105.76,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.29,
    y1: 112.87,
    x2: 72.6,
    y2: 112.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.29,
    y1: 119.97,
    x2: 72.6,
    y2: 119.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.29,
    y1: 127.08,
    x2: 72.6,
    y2: 127.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.29,
    y1: 134.18,
    x2: 72.6,
    y2: 134.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.62,100.2V91.79H28.9v-1h4.47v1H31.65v8.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.41,96.17l-1.57,4h-1l1.89-4.82L34,90.84h1.09l1.44,3.75L38,90.84h1l-1.75,4.54,1.87,4.82H38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25,100.2V91.79H39.52v-1H44v1H42.27v8.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "463.85 274 416.27 274 416.27 214.64 456.74 214.64 463.85 220.56 463.85 274",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.74 214.64 456.74 220.66 463.85 220.66 456.74 214.64",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 407.01,
    y: 219.64,
    width: 35.52,
    height: 12.97
  })), /*#__PURE__*/React.createElement("line", {
    x1: 421.53,
    y1: 236.32,
    x2: 459.83,
    y2: 236.32,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.53,
    y1: 243.42,
    x2: 459.83,
    y2: 243.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.53,
    y1: 250.52,
    x2: 459.83,
    y2: 250.52,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.53,
    y1: 257.63,
    x2: 459.83,
    y2: 257.63,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.53,
    y1: 264.73,
    x2: 459.83,
    y2: 264.73,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.86,230.76v-8.41h-1.73v-.95h4.48v.95h-1.72v8.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.65,226.72l-1.57,4h-1l1.89-4.83-1.77-4.53h1.08l1.45,3.74,1.46-3.74h1l-1.75,4.53,1.87,4.83H425.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.48,230.76v-8.41h-1.72v-.95h4.48v.95h-1.73v8.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "308.31 375.39 260.73 375.39 260.73 316.03 301.21 316.03 308.31 321.95 308.31 375.39",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.21 316.03 301.21 322.06 308.31 322.06 301.21 316.03",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 251.48,
    y: 321.03,
    width: 35.52,
    height: 12.97
  })), /*#__PURE__*/React.createElement("line", {
    x1: 266,
    y1: 337.71,
    x2: 304.3,
    y2: 337.71,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266,
    y1: 344.81,
    x2: 304.3,
    y2: 344.81,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266,
    y1: 351.91,
    x2: 304.3,
    y2: 351.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266,
    y1: 359.02,
    x2: 304.3,
    y2: 359.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266,
    y1: 366.12,
    x2: 304.3,
    y2: 366.12,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.32,332.15v-8.41H260.6v-.95h4.48v.95h-1.73v8.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.11,328.11l-1.57,4h-1l1.88-4.83-1.76-4.53h1.08l1.44,3.74,1.46-3.74h1l-1.76,4.53,1.88,4.83h-1.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,332.15v-8.41h-1.73v-.95h4.48v.95H274v8.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "96.32 287.45 32.24 287.45 32.24 207.51 86.76 207.51 96.32 215.48 96.32 287.45",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.76 207.51 86.76 215.62 96.32 215.62 86.76 207.51",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.78,
    y: 214.24,
    width: 47.84,
    height: 17.47
  })), /*#__PURE__*/React.createElement("line", {
    x1: 39.33,
    y1: 236.7,
    x2: 90.92,
    y2: 236.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.33,
    y1: 246.27,
    x2: 90.92,
    y2: 246.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.33,
    y1: 255.83,
    x2: 90.92,
    y2: 255.83,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.33,
    y1: 265.4,
    x2: 90.92,
    y2: 265.4,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.33,
    y1: 274.97,
    x2: 90.92,
    y2: 274.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.32,216.61c2,0,2.83,1.17,2.83,3.08v1.51c0,2-.94,3-2.94,3H34v5h-1.4v-12.6ZM35.21,223c1,0,1.55-.49,1.55-1.69v-1.68c0-1.15-.41-1.73-1.44-1.73H34V223Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.25,216.61c2,0,2.86,1.18,2.86,3.13v6.35c0,1.93-.9,3.12-2.86,3.12h-3v-12.6Zm0,11.32c1,0,1.5-.63,1.5-1.78v-6.48c0-1.16-.49-1.79-1.51-1.79H40.7v10.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.73,222.48v1.27h-2.9v5.46h-1.4v-12.6h5v1.27h-3.6v4.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "70 396.8 38.42 396.8 38.42 357.41 65.28 357.41 70 361.34 70 396.8",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.28 357.41 65.28 361.41 70 361.41 65.28 357.41",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.28,
    y: 360.72,
    width: 23.57,
    height: 8.61
  })), /*#__PURE__*/React.createElement("line", {
    x1: 41.92,
    y1: 371.79,
    x2: 67.34,
    y2: 371.79,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.92,
    y1: 376.51,
    x2: 67.34,
    y2: 376.51,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.92,
    y1: 381.22,
    x2: 67.34,
    y2: 381.22,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.92,
    y1: 385.94,
    x2: 67.34,
    y2: 385.94,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.92,
    y1: 390.65,
    x2: 67.34,
    y2: 390.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.94,361.89c1,0,1.39.58,1.39,1.52v.74c0,1-.46,1.5-1.45,1.5h-.61v2.45h-.69v-6.21ZM39.88,365c.52,0,.77-.24.77-.83v-.83c0-.56-.21-.85-.71-.85h-.67V365Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.35,361.89c1,0,1.41.59,1.41,1.55v3.13c0,.95-.44,1.53-1.41,1.53H41.9v-6.21Zm0,5.58c.5,0,.74-.31.74-.88V363.4c0-.57-.24-.88-.75-.88h-.74v5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.53,364.78v.63H46.1v2.69h-.69v-6.21h2.47v.63H46.1v2.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "471.47 104.39 439.89 104.39 439.89 64.99 466.75 64.99 471.47 68.92 471.47 104.39",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.75 64.99 466.75 68.99 471.47 68.99 466.75 64.99",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 433.75,
    y: 68.31,
    width: 23.57,
    height: 8.61
  })), /*#__PURE__*/React.createElement("line", {
    x1: 443.38,
    y1: 79.38,
    x2: 468.8,
    y2: 79.38,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.38,
    y1: 84.09,
    x2: 468.8,
    y2: 84.09,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.38,
    y1: 88.81,
    x2: 468.8,
    y2: 88.81,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.38,
    y1: 93.52,
    x2: 468.8,
    y2: 93.52,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.38,
    y1: 98.24,
    x2: 468.8,
    y2: 98.24,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.41,69.48c1,0,1.39.57,1.39,1.52v.74c0,1-.46,1.5-1.45,1.5h-.61v2.45h-.69V69.48Zm-.06,3.14c.52,0,.77-.24.77-.84V71c0-.57-.21-.85-.71-.85h-.67v2.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.82,69.48c1,0,1.41.58,1.41,1.54v3.13c0,.95-.44,1.54-1.41,1.54h-1.45V69.48Zm0,5.58c.5,0,.74-.31.74-.88V71c0-.57-.24-.88-.75-.88h-.74v5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,72.37V73h-1.43v2.69h-.69V69.48h2.47v.63h-1.78v2.26Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.02,
    y: 49.59,
    width: 334.46,
    height: 261.41,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 39.36,
    width: 335.47,
    height: 262.03,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 39.36,
    width: 335.47,
    height: 262.03,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 76.49,
    width: 71,
    height: 45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.5,
    y1: 96,
    x2: 150.5,
    y2: 96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 103.5,
    x2: 162.5,
    y2: 103.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 129.99,
    width: 71,
    height: 45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 140.67,
    x2: 133.29,
    y2: 140.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 146.63,
    x2: 133.29,
    y2: 146.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 152.59,
    x2: 133.29,
    y2: 152.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 158.55,
    x2: 133.29,
    y2: 158.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 164.51,
    x2: 133.29,
    y2: 164.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 140.67,
    x2: 164.12,
    y2: 140.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 146.63,
    x2: 164.12,
    y2: 146.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 152.59,
    x2: 164.12,
    y2: 152.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 158.55,
    x2: 164.12,
    y2: 158.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 164.51,
    x2: 164.12,
    y2: 164.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 183.49,
    width: 71,
    height: 45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 194.17,
    x2: 133.29,
    y2: 194.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 200.13,
    x2: 133.29,
    y2: 200.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 206.09,
    x2: 133.29,
    y2: 206.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 212.05,
    x2: 133.29,
    y2: 212.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 218.01,
    x2: 133.29,
    y2: 218.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 194.17,
    x2: 164.12,
    y2: 194.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 200.13,
    x2: 164.12,
    y2: 200.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 206.09,
    x2: 164.12,
    y2: 206.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 212.05,
    x2: 164.12,
    y2: 212.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 218.01,
    x2: 164.12,
    y2: 218.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 236.99,
    width: 71,
    height: 45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 247.67,
    x2: 133.29,
    y2: 247.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 253.63,
    x2: 133.29,
    y2: 253.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 259.59,
    x2: 133.29,
    y2: 259.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 265.55,
    x2: 133.29,
    y2: 265.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.39,
    y1: 271.51,
    x2: 133.29,
    y2: 271.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 247.67,
    x2: 164.12,
    y2: 247.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 253.63,
    x2: 164.12,
    y2: 253.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 259.59,
    x2: 164.12,
    y2: 259.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 265.55,
    x2: 164.12,
    y2: 265.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.22,
    y1: 271.51,
    x2: 164.12,
    y2: 271.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 39.36,
    width: 245.33,
    height: 262.03,
    style: {
      fill: "#b8b8b8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 89,
    width: 222,
    height: 151,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.58,
    y1: 148.94,
    x2: 362.42,
    y2: 148.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.02,
    y1: 162.18,
    x2: 378.98,
    y2: 162.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.66,
    y: 39.36,
    width: 8.67,
    height: 262.03,
    style: {
      fill: "#dbdbdb",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.66,
    y: 120.54,
    width: 8.67,
    height: 70.8,
    style: {
      fill: "#878787"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.87,
    y: 39.36,
    width: 335.47,
    height: 17.02,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.93,
    y: 42.26,
    width: 215.68,
    height: 9.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.99,
    y1: 62.4,
    x2: 394.34,
    y2: 62.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.99,
    y1: 67.53,
    x2: 394.34,
    y2: 67.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.99,
    y1: 72.65,
    x2: 394.34,
    y2: 72.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-66"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 431,
    y1: 408.44,
    x2: 435.05,
    y2: 396.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.29,
    y1: 377.17,
    x2: 431.29,
    y2: 420.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.65,399.55s-6-6.55-12-5.46-8.74,8.2-8.74,12.57,6,18.57,6,18.57,4.37-4.91,14.21-12S434.49,399,424.65,399.55Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.65,399.55a30.06,30.06,0,0,0-12,12.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.45,391.86s5-5.39,9.91-4.48,7.19,6.77,7.18,10.37-5,15.3-5,15.3a78.5,78.5,0,0,0-11.67-9.94C426.78,397.24,426.34,391.39,434.45,391.86Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.45,391.86a24.67,24.67,0,0,1,9.87,10.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.42,
    y1: 384.7,
    x2: 437.95,
    y2: 373.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.16,381.51s-.12-7.32-4.43-9.93-9.86.27-12.25,3S406,389.29,406,389.29s5.38-.65,15.33.35S435.52,386.55,429.16,381.51Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.16,381.51a24.76,24.76,0,0,0-14.28,1.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.63,371.69s.09-5.39,3.26-7.31,7.27.2,9,2.18,4.75,10.85,4.75,10.85a57.82,57.82,0,0,0-11.28.26C434.06,378.4,431,375.4,435.63,371.69Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.63,371.69a18.21,18.21,0,0,1,10.51.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.69 416.61 410.88 416.61 414.81 457.01 445.76 457.01 449.69 416.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.4,434.21a1.74,1.74,0,1,0,1.74-1.74A1.73,1.73,0,0,0,439.4,434.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,434.21a1.74,1.74,0,1,0,1.74-1.74A1.73,1.73,0,0,0,433,434.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.17 429.86 448.4 429.86 448.57 428.13 412 428.13 412.17 429.86",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.85 445.79 447.58 438.26 412.99 438.26 413.72 445.79 446.85 445.79",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.77,434.21a1.73,1.73,0,0,0,1.74,1.73l.3,0,.32-3.32a1.8,1.8,0,0,0-.62-.12A1.74,1.74,0,0,0,445.77,434.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.66,434.21a1.74,1.74,0,1,0,1.74-1.74A1.73,1.73,0,0,0,426.66,434.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.92,434.21a1.74,1.74,0,1,0,1.74-1.74A1.73,1.73,0,0,0,413.92,434.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.29,434.21a1.74,1.74,0,1,0,1.74-1.74A1.73,1.73,0,0,0,420.29,434.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.27,457.11c4.8-5.92,13.37-16.36,16.32-19.1a98.07,98.07,0,0,0,8-8.64s-5.07,9.83,3.57,17.58,34.28,1.79,39.94-2.38,6.26-14.9,1.2-30.7-12.23-45-11.93-55.14-6.26-38.75-9.24-46.5-15.2-13.41-27.72-16.09-46.2,11.32-46.2,11.32l-6.85,2.68s-28,15.5-35.47,21.76-3.88,23.55-5.66,40.24-1.79,36.07-1.79,36.07-17.29,15.2-29.81,32.48c-6,8.32-9.49,13.39-11.47,16.42Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.74,424.82s-10-2.35-20.48,4.68-7.62,17.56,1.75,19.9,21.66,2.34,28.1-7.61S232.43,424.23,227.74,424.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.23,424.73a22,22,0,0,0-16,3.66c-8.22,5.48-5.94,13.71,1.37,15.54s16.91,1.83,21.94-5.94S233.88,424.28,230.23,424.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.09,358.07c.33-5.44.54-9.15.54-9.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.64,429.37s10.73-10.43,12.51-22.36c1.11-7.35,2.55-27.38,3.49-41.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.77,378.27c-2.7,8.68-7.7,21.71-15.42,30.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.23,369.16s-.42,2-1.31,5.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.29,403.15a73.22,73.22,0,0,1-18.43,15.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4,396.58a52,52,0,0,1-3.55,4.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.84,421.92a49.29,49.29,0,0,0-30.41.59c-16.69,5.67-14.9,18.48-13.41,20.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,214.21s0-3.51-4.83-11-29.42-4.39-37.76,3.95,3.51,18.88-1.76,25-22.83,3.07-28.54,14.05,8.78,16.24,11.86,20.19-5.27,5.27-4.39,9.22,14.48,4.39,14.48,4.39-8.78,2.64-4.39,6.15a32.7,32.7,0,0,0,21.08,6.59c8.78-.44,6.58-17.57,5.71-30.3s10.53-26.78,23.71-25.47,27.22,16.25,25,22.84,3.51-1.32,15.37-8.79,6.59-22.83,4-25.9-11.41-3.95-13.17-9.66-5.71-11.41-13.17-11.41S199.06,213.77,191.6,214.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,293.15s-5.66,1.49-8,4.48S134,306,133.41,310.14s3,25.64,10.13,34.28,10.73,9.24,10.73,9.24,2.09-8.34,3.58-8.94,15.2,8,15.2,8,2.38-14,3.88-14,6.25,4.77,6.25,4.77,1.79-11.93.6-21.17-8.94-20.56-14.6-24.44S159,290.47,154,293.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.91,281.83l-11,26.34s2.83,12.27,6.55,20.16c5.07,10.73,17.6,15.84,17.6,15.84a40.6,40.6,0,0,1,3.95-18,97.94,97.94,0,0,1,8.78-14.49S163.06,292.37,156.91,281.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.75,291.82s5.05,28.87,12.27,37.89l6.85-13-18-28.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.46,377.51s17.59-45.91,20-48.59,7.75-7.45,10.14-10.73,8.94-11.62,11.33-11.62,8,2.08,10.73,2.68,4.47,1.49,4.76,6-3.57,4.77-3.57,4.77l-1.49-1.79s-10.73,16.1-14,18.18a27.85,27.85,0,0,1-6.26,3l-14.31,53.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.5,244.39s4.17,3.48,1.39,15.28-3.47,17.71-3.47,24.66-2.08,16.67-8,22.92-13.19,15.28-21.87,14.93c-13.75-.55-20.49-19.45-25-28.13S155,273.56,155,268.7s.69-16.32,6.94-25,23.27-12.15,30.56-11.11S208.82,234.67,217.5,244.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.12,275.65s1.39-4.86,7.64-7.64,10.07-7.64,8-12.16-1-9,8-11.46,11.46,6.6,20.14,5.21,11.11-4.86,15.62-2.78,2.43,8,2.43,8,5.56-10.07-5.2-21.53-36.81-15.63-54.87-2.43-7.64,44.1-7.64,44.1S153.26,276.34,158.12,275.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "201.53 281.55 200.49 301.69 193.19 298.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,309s-6.94,1-10.07-3.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.31,281.34c-.32,2-1.43,3.46-2.47,3.29s-1.62-1.92-1.3-3.91,1.43-3.46,2.47-3.29S188.63,279.35,188.31,281.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.56,281.9c-.32,2-1.43,3.46-2.47,3.29s-1.63-1.92-1.3-3.9,1.43-3.47,2.47-3.3S210.88,279.91,210.56,281.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.44,272.27s7.47-6.51,13.49-1.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.7,270.82s5.06-4.33,9.4-.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75,276.61s-10.6-1.69-27,1c0,0-1.44,11.08,6.27,15.9s15.18.24,17.1-2.41C198,285.82,197.75,276.61,197.75,276.61Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.08,275.09s-7.58-1.61-19.3.92c0,0-1,10.6,4.48,15.2s10.86.23,12.24-2.3C222.22,283.9,222.08,275.09,222.08,275.09Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75,276.61s1.14-3.12,5-.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.62,
    y1: 271.06,
    x2: 170.76,
    y2: 277.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.51,277.38s-2.43-14.23-9-7.29-.69,13.89,2.43,17,7,0,7,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.49,347.54A79.37,79.37,0,0,1,142.05,373c2.09,14.31,1.79,17,1.79,17l10.43-12.51s17,11.92,19.67,15.79,3,5.07,3,5.07,0,23.25-9.84,37.26-14.61,14-24.14,14-21.76-8.95-28.32-23.85S102.71,389.13,101.52,387s-5.07-14-5.07-14",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.58,407.49c-1.09,1.28-2,2.35-2.73,3.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.84,390s-5.57,7-10.57,13.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.33,388.53a77.87,77.87,0,0,1,18.48,8.05c10.13,6,11,12.52,14,10.14s5.36-9.84,2.38-14-12.22-14-18.77-17-9.24-1.2-11.33,3.28S143.24,385.85,145.33,388.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,412.93a34.35,34.35,0,0,0,1.28,8.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.33,388.53s-.71,10-.56,19.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.46,393.6s2.09,11.63,4.48,16.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.11,422.51s-10.14,17.89-8.65,20,34.58,0,34.58,0l1.78-7.15s6.86,2.68,12.23,2.68,1.19-1.49-.6-3.28-12.22-8.34-13.12-8.94S234.15,420.72,226.11,422.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.7,420.45s4.79-1.44,6.07,1.6.64,16,.16,19.32-2.71,3.19-3.67,0-3.2-20.44-3.2-20.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.64,421.89s7.19-4.95,9.27-2.4,4,22.68,4.63,24.12-2.72,2.55-4,1.11-4.95-8.78-6.06-11.49S237.64,421.89,237.64,421.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.43,427.32s4-7.35,7.35-9.42,7,1.75,8.78,4.63,3.19,10.38,4,14.05,3,7.82,1.76,8.3-6.23-3.67-7.67-5.9-4.95-10.86-4.95-10.86",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,441.21s-5.75-5.59-7.67-7.35-4.63-2.55-6.54-.47-2.88,4.63,0,7.34S225.51,447,230,447s3.67-2.24,2.55-3.51A14.51,14.51,0,0,0,230,441.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.09,
    y: 451.02,
    width: 209.55,
    height: 5.99,
    transform: "translate(555.73 908.03) rotate(180)",
    style: {
      fill: "#b8b8b8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.09,
    y: 451.02,
    width: 73.56,
    height: 5.99,
    transform: "translate(419.74 908.03) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.72,451H376.78l7.86-90.49a7.05,7.05,0,0,0-7.13-7.81H257.06a8.69,8.69,0,0,0-8.48,7.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.33,451H379.39l7.86-90.49a7.05,7.05,0,0,0-7.13-7.81H259.67a8.69,8.69,0,0,0-8.48,7.81Z",
    style: {
      fill: "#b8b8b8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.27,399a9.49,9.49,0,0,1,9.27-8.53,7.7,7.7,0,0,1,7.79,8.53,9.49,9.49,0,0,1-9.27,8.53A7.7,7.7,0,0,1,312.27,399Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-66"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 486.03,
    y1: 457.01,
    x2: 17.42,
    y2: 457.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.9d11925a917505b2290ce474eaa8b7c0.svg";
export { ForwardRef as ReactComponent };